import { WeightIcon } from 'lucide-react'
import { FC } from 'react'

import { UserPkg } from '@/api/user-package/types/UserPkg'
import ContentIcon from '@/components/icons/content.svg?react'
import DimensionsIcon from '@/components/icons/dimenstions.svg?react'
import FlamableIcon from '@/components/icons/flamable.svg?react'
import LocationIcon from '@/components/icons/location.svg?react'
import PackageActionIcon from '@/components/icons/package-action.svg?react'
import TrackingNumberIcon from '@/components/icons/tracking-number.svg?react'
import { warehouseToLabel } from '@/components/WarehousePreview'
import { cn } from '@/lib/utils'

const DetailField = ({
  label,
  value,
  IconComponent,
  valueProps,
}: {
  label: string
  value: string
  IconComponent: FC<React.SVGProps<SVGSVGElement>>
  valueProps?: React.HTMLAttributes<HTMLParagraphElement>
}) => {
  return (
    <div className='flex items-center justify-between gap-6'>
      <div className='flex items-center gap-1'>
        <IconComponent className='text-text-secondary size-[18px]' />
        <p className='text-text-secondary text-xs'>{label}</p>
      </div>
      <p {...(valueProps || {})} className={cn('max-w-40 text-end text-xs', valueProps?.className)}>
        {value}
      </p>
    </div>
  )
}
interface Props {
  pkg: UserPkg
}
export default function ClientPkgDetails({ pkg }: Props) {
  return (
    <div dir='rtl' className='flex w-full flex-col items-center'>
      <div className='mb-6 flex flex-col items-center'>
        <PackageActionIcon />
        <h3 className='text-text-primary font-medium'>פרטי חבילה</h3>
      </div>

      <div className='w-full space-y-4'>
        {pkg.isShipped ? (
          <DetailField label='מספר מעקב' value={pkg.toTrackingNumber} IconComponent={TrackingNumberIcon} />
        ) : (
          <DetailField
            label='מספר מעקב מקומי'
            value={pkg.fromTrackingNumber}
            IconComponent={TrackingNumberIcon}
            valueProps={{ className: 'max-w-[120px] text-wrap wrap-anywhere text-left', dir: 'ltr', title: pkg.fromTrackingNumber }}
          />
        )}
        <DetailField label='מדינת המשלוח' value={warehouseToLabel[pkg.warehouse]} IconComponent={LocationIcon} />
        <DetailField
          label='מידות'
          value={`${pkg.dimensions.length}x${pkg.dimensions.width}x${pkg.dimensions.height} ס״מ`}
          IconComponent={DimensionsIcon}
        />
        <DetailField label='משקל פיזי' value={`${pkg.dimensions.weight}KG`} IconComponent={WeightIcon} />
        <DetailField label='פריטים דליקים' value={pkg.isFlammable ? 'כן' : 'לא'} IconComponent={FlamableIcon} />
        <DetailField
          label='פריטים בחבילה'
          value={pkg.contents.map(c => `${c.quantity} ${c.productCategory}`).join(', ')}
          IconComponent={ContentIcon}
          valueProps={{ dir: 'ltr', className: 'text-left' }}
        />
      </div>
    </div>
  )
}
